// extracted by mini-css-extract-plugin
export default {"wrapper":"NewSearch__wrapper___sxHn9"};